import { useContext } from 'react';
import { OrganizationContext } from 'src/contexts/organization-context-types';


// ----------------------------------------------------------------------

export const useOrganizationContext = () => {
  const context = useContext(OrganizationContext);

  if (!context) throw new Error('useAuthContext context must be use inside OrganizationProvider');

  return context;
};
